/*
 * curried function which takes factors first, factors being a map of units to ratios
 * e.g. { px: 1, dpi: 4 }, then return a function which converts a value from one unit
 * to the other using the factors scaling
 *
 * convertUnit({ px: 1, dpi: 4 })(4, 'px', 'dpi') -> 16
 */

module.exports = function convertUnit (factors) {
  return function converter (value, fromUnit, toUnit) {
    return value * (factors[toUnit] / factors[fromUnit])
  }
}
